import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { PENSION_INSURANCE_MENU } from 'src/constants/Generals';
import { CLIENT_PENSION_INSURANCE_FORM } from 'src/constants/FormNames';
import { TextField, Label } from 'jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import { getPensionInsuranceFormValues } from 'src/reducers/clients/insurance';
import * as CssClassNames from 'src/constants/CssClassNames';
import { digitFloatingNumber, exactLength5, isNumber } from 'src/utils/CustomValidators';
import selector, { sumFloatNumberFixed5, toFloatString } from 'src/utils/Utils';
import InsuranceSetting from 'src/features/Clients/components/InsuranceSetting';
import { ErrorsSection, InsurancePeriodSetting } from 'src/components';
import OrganizationSymbol from './OrganizationSymbol';
import styles from './PensionInsuranceCreatingForm.scss';

const updateFields = [
  'childcareRateForEmployee',
  'childcareRateForEmployer',
  'organizationNumber',
  'organizationSymbol',
  'organizationSymbolPart0',
  'organizationSymbolPart1',
  'salaryRateForEmployee',
  'salaryRateForEmployer'
];

const PensionInsuranceCreatingForm = props => {
  const {
    submit,
    submitting,
    handleSubmit,
    errors,
    salaryRateForEmployee,
    salaryRateForEmployer,
    childcareRateForEmployee,
    childcareRateForEmployer
  } = props;

  return (
    <div className={styles.wrap}>
      <InsuranceSetting activeMenu={PENSION_INSURANCE_MENU}>
        <div>
          <form
            className={classNames(
              CssClassNames.FORM,
              CssClassNames.CLIENT_INSURANCE_FORM,
              CssClassNames.CLIENT_PENSION_INSURANCE
            )}
            onSubmit={handleSubmit}
          >
            <ErrorsSection errors={errors} />

            <OrganizationSymbol />

            <TextField
              label="厚生年金保険番号（事業所番号）"
              type="text"
              name="organizationNumber"
              validate={[exactLength5, isNumber]}
              maxLength="5"
              note="年金事務所から付与される5桁の数字です。「適用通知書」や「保険料納入告知額・領収済額通知書」などに記載されています。"
            />

            <div className={styles.inner}>
              <InsurancePeriodSetting
                formName={CLIENT_PENSION_INSURANCE_FORM}
                fieldName="settingStartDate"
                updateFields={updateFields}
                insuranceType="pensionInsurance"
              />
              <Label text="保険料率" />
              <div className="l-overflow-scroll">
                <table className={`${styles.table} m-table-list`}>
                  <thead>
                    <tr>
                      <th className={styles.name}>保険名</th>
                      <th>従業員負担（％）</th>
                      <th>事業主負担（％）</th>
                      <th className={styles.sum}>合計（％）</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>厚生年金保険</td>
                      <td>
                        <TextField name="salaryRateForEmployee" type="text" validate={digitFloatingNumber} disabled />
                      </td>
                      <td>
                        <TextField name="salaryRateForEmployer" type="text" validate={digitFloatingNumber} disabled />
                      </td>
                      <td>
                        <span>{toFloatString(sumFloatNumberFixed5(salaryRateForEmployee, salaryRateForEmployer))}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>子ども・子育て拠出金</td>
                      <td>
                        <TextField
                          name="childcareRateForEmployee"
                          type="text"
                          validate={digitFloatingNumber}
                          disabled
                        />
                      </td>
                      <td>
                        <TextField
                          name="childcareRateForEmployer"
                          type="text"
                          validate={digitFloatingNumber}
                          disabled
                        />
                      </td>
                      <td>
                        <span>
                          {toFloatString(sumFloatNumberFixed5(childcareRateForEmployee, childcareRateForEmployer))}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="u-ta-c u-mt20">
              <Button primary disabled={submitting} onClick={submit}>
                保存
              </Button>
            </div>
          </form>
        </div>
      </InsuranceSetting>
    </div>
  );
};

export default connect(state => ({
  salaryRateForEmployee: selector(getPensionInsuranceFormValues(state), 'salaryRateForEmployee'),
  salaryRateForEmployer: selector(getPensionInsuranceFormValues(state), 'salaryRateForEmployer'),
  childcareRateForEmployee: selector(getPensionInsuranceFormValues(state), 'childcareRateForEmployee'),
  childcareRateForEmployer: selector(getPensionInsuranceFormValues(state), 'childcareRateForEmployer')
}))(PensionInsuranceCreatingForm);
